export const events = {
  NEW_ERROR: "NEW_ERROR",
  NEW_CONVERSATION: "NEW_CONVERSATION",
  NEW_DISCUSSION: "NEW_DISCUSSION",
  DISCUSSION_CONTENT_UPDATE: "DISCUSSION_CONTENT_UPDATE",
  DISCUSSION_CONTENT_UPDATE1: "DISCUSSION_CONTENT_UPDATE1",
  POST_CONTENT_UPDATE: "POST_CONTENT_UPDATE",
  POST_CONTENT_UPDATE1: "POST_CONTENT_UPDATE1",
  ADD_POST_TO_DISCUSSION: "ADD_POST_TO_DISCUSSION",
  CLOSE_ALL_REACTION_PICKERS: "CLOSE_ALL_REACTION_PICKERS",
  EMOJI_CHANGED: "EMOJI_CHANGED",
  NEW_REPLY: "NEW_REPLY",
  DELETE_MESSAGE: "DELETE_MESSAGE",
  OPEN_REACTION: "OPEN_REACTION",
  CLOSE_ALL_REACTION_PICKERS1: "CLOSE_ALL_REACTION_PICKERS1",
  REACTION_CHANGED: "REACTION_CHANGED",
  COMMENT_REPLY: "COMMENT_REPLY",
  POLL_CREATED: "POLL_CREATED",
};
